<div>
    <app-banner [storeview]="this.authService.storeview" ></app-banner>
    <div class="pl-4 pr-4">
<!--        <div class="container-fluid">-->
<!--            <app-product-slider [title]="'modern_chandeliers'|translate" [sliderType]="'category'"  [categoryId]="this.cat1"-->
<!--            ></app-product-slider>-->
<!--        </div>-->

        <div class="container-fluid" *ngIf="this.cat2">

            <app-product-slider [title]="catTitle2" [sliderType]="'category'"
                                [categoryId]="this.cat2"
                                ></app-product-slider>
        </div>

<!--        <div class="container-fluid pe-5 ps-5 pt-3 pb-3 " style="min-height: 400px ;">-->
<!--            <div class="slider-header">-->

<!--                <div class="text-left"><h3>{{'latest_events'| translate}}</h3></div>-->



<!--            </div>-->

<!--            <app-wordpress-posts-list [category_id]="5"></app-wordpress-posts-list>-->

<!--        </div>-->

        <div class=" m-auto mb-2 text-center" style="padding-left: 12px;padding-right: 12px;">
            <a target="_blank" href="https://kontrolc.com/" ><img style="border-radius: 20px;margin-bottom: 40px;width: 100%" class="img-fluid" src="assets/banners/GeneratorsWebPost-min.jpg"></a>
        </div>




        <div class="">
            <app-html-widget></app-html-widget>
        </div>

        <div class="">
            <!--            <app-offers></app-offers>-->
        </div>


        

        <div *ngIf="campaigns">
            <div *ngFor="let c of campaigns">
                <app-text-ad *ngIf="(c.show_campaign_banner == 1 && c.website_id == registry.websiteId)"></app-text-ad>
            </div>
        </div>

        <div class="pt-3">
            <div class="text-left"><h3>{{'our_picks'| translate}}</h3></div>
            <div class="row">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">

                    <app-ad-card-mini [image]="'assets/Electrical_Extensions.jpeg'" [bg_color]="'#fff'"
                                      [price]="'4.93'"
                                      [title]="'electrical_extensions'|translate"
                                      [link]="'/web/home/categories/1099'"
                                      [subheading]="'indoor_outdoor'|translate"></app-ad-card-mini>


                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <app-ad-card-mini [image-space]="4" [image]="'assets/modern_lamp.jpeg'"
                                      [bg_color]="'#fff'"

                                      [link]="'/product/details/byk/mt8042%0D%0Awirelesschargemetal%2Bglassl200*h620/010405011302100402'"
                                      [price]="'4.420'" [title]="'modern_table_lamp'|translate"
                                      [subheading]="'smart_compact'|translate"></app-ad-card-mini>

                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <app-ad-card-mini [image-space]="4"
                                      [image]="'assets/modern_chandilires.jpeg'"
                                      [bg_color]="'#fff'" [price]="'2.5'"
                                      [link]="'/product/details/byk/cl150148a1870w/010401010903106801'"
                                      [title]="'ultra_modern_chandelier'|translate" [subheading]="''"></app-ad-card-mini>

                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <app-ad-card-mini [image-space]="4"
                                      [image]="'assets/light2.jpg'"
                                      [bg_color]="'#fff'" [price]="'2.5'"
                                      [link]="'/product/details/byk/lwq010112w3000kwhd60*h180mm/010308050101104701'"
                                      [title]="'track_light'|translate" [subheading]="''"></app-ad-card-mini>

                </div>
            </div>
            <div class="row">


                <div class="col-md-12 col-lg-6 col-sm-12">
                    <app-ad-card-mini [image]="'assets/chand.png'" [bg_color]="'#223046'"
                                      [image-space]="'6'"
                                      [price]="'8.7'"
                                      [title]="'classic_chandeliers'|translate"
                                      [title_color]="'#fff'"
                                      [link]="'/web/home/categories/855'"
                                      [subtitle_color]="'#fff'"
                                      [subheading]="'for_a_modern_life'| translate"></app-ad-card-mini>

                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">

                    <app-ad-card-mini [image]="'assets/fan.jpeg'"
                                      [bg_color]="'#fff'"
                                      [price]="'4.93'"
                                      [image-space]="'4'"
                                      [title]="'alarabiya_exhaust_fans'|translate"
                                      [link]="'/web/home/categories/1212'"
                                      [subheading]="''|translate"></app-ad-card-mini>


                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">

                    <app-ad-card-mini [image]="'assets/lamp.jpeg'"
                                      [bg_color]="'#fff'"
                                      [image-space]="'4'"
                                      [price]="'4.93'"
                                      [title]="'handmade_table_lamps'|translate"
                                      [link]="'/web/home/categories/885'"
                                      [subheading]="''|translate"></app-ad-card-mini>


                </div>

            </div>
        </div>


        <div class="container-fluid">
            <app-product-slider [title]="catTitle3" [sliderType]="'category'" [categoryId]="863"
                               ></app-product-slider>
        </div>

        <div class="container-fluid " *ngIf="this.cat1">
            <app-product-slider [title]="catTitle1" [sliderType]="'category'"
                                [categoryId]="this.cat1"
            ></app-product-slider>
        </div>


    </div>


    <div class="container-fluid p-0">

<!--        <app-brands></app-brands>-->
        <app-brands-comp></app-brands-comp>
    </div>




</div>
